import { useStore } from '../Store/storeProvider';
import useCookiesHandler from "./useCookiesHandler";
import useLogout from '../Services/_LogoutService';
import { trackCustomEvent } from "../Config/DataDog";
import { deleteCallbackEmailVerification, getCallbackEmailVerification } from '../Helpers/Auth0StorageManager';
import UCL from '../Helpers/UserClientLibs';

const useLoginAuth0Handler = () => {
    const { Config } = useStore();
    const [CookiesHandler] = useCookiesHandler();
    const handleLogout = useLogout();

    const loginAuth0Handler = async () => {
        try {
            let userCallbackEmailVerification = getCallbackEmailVerification();
            if (userCallbackEmailVerification == null) {
                userCallbackEmailVerification = Config.URLCallback
            } else {
                deleteCallbackEmailVerification();
            }
            await CookiesHandler(userCallbackEmailVerification);
        } catch (error) {
            const userData = await UCL.GetUserInfo();
            const {ln_user_id, email} = userData;
            
            trackCustomEvent("logout", true, { message: `useLoginAuth0Handler - ${error.message}`, ln_user_id, email });
            handleLogout();
        }
    };
    return [loginAuth0Handler];
};
export default useLoginAuth0Handler;